var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg38(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0.8539651868623236"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.5 0L0 142H51.433L31.5 253L143 111H91.567L111.5 0Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 0L0 142H51.433L31.5 253L143 111H91.567L111.5 0Z",
    fill: "rgba(191, 191, 191, 100)",
    transform: "scale(2.097902097902098, 1.1857707509881423)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 0L0 142H51.433L31.5 253L143 111H91.567L111.5 0Z",
    fill: "none",
    stroke: "#0c0c0c",
    strokeWidth: 0,
    clipPath: "url(#clip-0.8539651868623236)",
    transform: "scale(2.097902097902098, 1.1857707509881423)",
    strokeDasharray: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg38);
export default __webpack_public_path__ + "static/media/38.a67eebe7a0ca97b938c4646932249187.svg";
export { ForwardRef as ReactComponent };